import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export const Hero = () => {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-41">
      {/* Decorative background element — desktop only, very subtle so it never fights with the copy */}
      <div aria-hidden="true" className="hidden md:block absolute right-[-8%] top-1/2 -translate-y-1/2 text-[36rem] font-serif text-ink/[0.04] select-none pointer-events-none leading-none" data-id="element-42">
        $
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 w-full" data-id="element-43">
        <div className="grid md:grid-cols-[1.2fr_0.8fr] gap-12 items-center" data-id="element-44">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="space-y-8" data-id="element-45">
            <div className="inline-block border-b border-ink/30 pb-1" data-id="element-46">
              <span className="uppercase tracking-widest text-xs font-semibold text-ink/70" data-id="element-47">
                MANUAL DIGITAL · ARGENTINA 🇦🇷
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-medium leading-[1.05] text-ink tracking-tight" data-id="element-48">
              Cobrá en Dólares. <br className="hidden md:block" data-id="element-49" />
              <span className="italic text-accent" data-id="element-50">Sin Jefe. Sin Inglés.</span>
            </h1>

            <p className="text-lg md:text-xl font-sans text-ink/80 leading-relaxed max-w-2xl" data-id="element-51">
              Aprendé la habilidad que usan los argentinos para ganar $500 USD o
              más desde casa, sin títulos universitarios y sin saber inglés
              nivel bilingüe.
            </p>

            <div className="pt-4" data-id="element-52">
              <Button href="#oferta" className="w-full md:w-auto text-sm md:text-base" data-id="element-53">
                QUIERO EMPEZAR A COBRAR EN DÓLARES YA
              </Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="hidden md:flex justify-center relative" data-id="element-54">
            <div className="relative w-full max-w-md" data-id="element-55">
              {/* Soft sepia backdrop to anchor the image to the page */}
              <div className="absolute inset-0 -m-4 bg-sepia/40 rounded-sm rotate-2" data-id="element-56"></div>
              <div className="relative overflow-hidden rounded-sm shadow-2xl border border-ink/15" data-id="element-57">
                <img src="https://cdn.magicpatterns.com/uploads/wdBqSJi2QosVYgX7f5tEC8/heylloyd-image-1779119654340.png" alt="El Manual del Appointment Setter en tablet y celular — vista previa del producto digital" className="w-full h-auto block" data-id="element-58" />
              </div>
              {/* Small caption tag */}
              <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-ink text-paper px-4 py-1.5 text-[10px] uppercase tracking-widest font-sans font-semibold shadow-lg whitespace-nowrap" data-id="element-59">
                Acceso Inmediato · PDF
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};